import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useStarFavoredContactMutation, useUnstarFavoredContactMutation } from '../../services/pixFavoredContactApi';
export function useStarAndUnstarFavoredContact() {
    const { t } = useTranslation();
    const [triggerStar] = useStarFavoredContactMutation();
    const [triggerUnstar] = useUnstarFavoredContactMutation();
    const [loading, setLoading] = useState(false);
    const [errorStarFavoredContactMessage, setErrorStarFavoredContactMessage] = useState();
    const [errorUnstarFavoredContactMessage, setErrorUnstarFavoredContactMessage] = useState();
    const [favoredContacts, setFavoredContacts] = useState();
    const [favoredBankContacts, setFavoredBankContacts] = useState();
    async function starFavoredContact(contactId) {
        setLoading(true);
        setErrorStarFavoredContactMessage(undefined);
        try {
            const { error } = await triggerStar({ contactId });
            if (error) {
                setErrorStarFavoredContactMessage(t('select-contact-star-contact-error-message'));
                return;
            }
            return true;
        }
        catch {
            setErrorStarFavoredContactMessage(t('select-contact-star-contact-error-message'));
        }
        finally {
            setLoading(false);
        }
    }
    async function unstarFavoredContact(contactId) {
        setLoading(true);
        setErrorStarFavoredContactMessage(undefined);
        try {
            const { error } = await triggerUnstar({ contactId });
            if (error) {
                setErrorUnstarFavoredContactMessage(t('select-contact-unstar-contact-error-message'));
                return;
            }
            return true;
        }
        catch {
            setErrorUnstarFavoredContactMessage(t('select-contact-unstar-contact-error-message'));
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        errorStarFavoredContactMessage,
        setErrorStarFavoredContactMessage,
        errorUnstarFavoredContactMessage,
        setErrorUnstarFavoredContactMessage,
        setLoading,
        favoredContacts,
        setFavoredContacts,
        favoredBankContacts,
        setFavoredBankContacts,
        starFavoredContact,
        unstarFavoredContact,
    };
}
